import React from "react";
import { translationKeys } from "../../../../contexts/I18nContext";
import { useTranslation } from "../../../../hooks/useTranslation";
import { DocumentDto, DocumentType } from "../../../../data/types";
import { useSnackbarContext } from "../../../shared/Snackbar";
import { downloadFile } from "../../../../utils/downloadUtils";
import { DocumentsClient } from "../../../../data/clients";

export function useDownload(document: DocumentDto) {
  const { getTranslation: t } = useTranslation();

  const snack = useSnackbarContext();
  const [downloading, setDownloading] = React.useState<boolean>(false);

  const download = async (item: DocumentDto) => {
    setDownloading(true);

    snack.showSnackbar({
      message: t(translationKeys.DOCUMENT_DATAGRID_DOWNLOAD_SNACKBAR_INFO),
      severity: "info",
    });

    let url: string;
    if (item.url) url = item.url;
    else if (document.type === DocumentType.MONTHLY_STATEMENT)
      url = await DocumentsClient.getStatementUrl(item);
    else url = await DocumentsClient.getDocumentUrl(item);

    setDownloading(false);

    if (url) {
      snack.hideSnackbar();
      downloadFile(url);
    } else {
      snack.showSnackbar({
        message: t(translationKeys.DOCUMENT_DATAGRID_DOWNLOAD_SNACKBAR_FAILED),
        severity: "error",
      });
    }
  };

  return {
    downloading,
    download,
  };
}
